import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    userReady: false,
    isFooter: false,
    location: {
      prop: {
        name: null,
        id: null,
      },
      area: {
        id: null,
        code: null,
        name: null,
      },
      pref: {
        id: null,
        code: null,
        name: null,
      },
      city: {
        id: null,
        code: null,
        name: null,
      },
      station: {
        id: null,
        code: null,
        name: null,
      },
    },
    prop: {},
    favorite: [],
    compare: [],
    view: [],
    search: [],
  },
  getters: {
    getLocation(state) {
      return state.location;
    },
    getFavorite(state) {
      return state.favorite;
    },
    getCompare(state) {
      let result;
      if (state.compare.length < 1) {
        result = JSON.parse(localStorage.getItem('compare'));
      } else {
        result = state.compare;
      }
      return result;
    },
    getViewHistory(state) {
      return state.view;
    },
    getSearchHistory(state) {
      return state.search;
    },
    getProp(state) {
      return state.prop;
    },
    getUser(state) {
      return state.user;
    },
    getUserReady(state) {
      return state.userReady;
    },
    getFooterDisplayFlag(state) {
      return state.isFooter;
    },
  },
  mutations: {
    // ユーザー情報保存
    setUser(state, user) {
      state.user = user;
    },
    setLocation(state, location) {
      state.location = location;
    },
    setFavorite(state, favorite) {
      state.favorite = favorite;
      // localStorage.setItem('fav', JSON.stringify(favorite));
    },
    setCompare(state, compare) {
      localStorage.setItem('compare', JSON.stringify(compare));
      state.compare = compare;
    },
    setViewHistory(state, view) {
      state.view = view;
      // localStorage.setItem('view', JSON.stringify(view));
    },
    setSearchHistory(state, search) {
      state.search = search;
      // localStorage.setItem('search', JSON.stringify(search));
    },
    setProp(state, prop) {
      state.prop = prop;
    },
    userReady(state) {
      state.userReady = true;
    },
    setFooterDisplayFlag(state) {
      state.isFooter = true;
    },
  },
  actions: {
  },
  modules: {
  },
});

